/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import { useMap } from "react-leaflet";
import { popupcontext } from "../../../../context/Popupscontext";
import Close from "../../../Helpers/CloseBtn/Close";
import trans from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";

export default function TrackedSelectedHead({ values, device, setimei }) {
	let { handleClose } = useContext(popupcontext);
	const map = useMap();
	const truncateItem = (text) => {
		const maxLength = 25;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	console.log("device in head", device, "Values", values);
	return (
		<>
			<div
				style={{
					paddingBlock: "12px",
					paddingInline: "16px",
					height: "69px",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div>
					<p
						className="ms-2 me-3 my-0 fs-16 fw-600 text-capitalize"
						title={values?.name}
					>
						{truncateItem(values?.name)}
					</p>
					<div
						className="ms-2"
						style={{ color: "#42526E73" }}
					>{`${trans("Last Update")}: ${formatDateString(device?.lastUpdate ? device?.lastUpdate : values?.lastUpdate)}`}</div>
				</div>
				<Close
					style="close close-32"
					close={() => {
						handleClose("objectSelected");
						setimei(null);
						map.scrollWheelZoom.enable();
						map.dragging.enable();
					}}
					img="Close"
				/>
			</div>
		</>
	);
}
